import { useContext, useEffect, useState } from 'react';
import { Box, colors, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import MenuButton from '../../Shared/MenuButton';
import { useNavigate } from 'react-router-dom';
import { GameContext } from '../../../contexts/GameContext';
import PlaySoundBar from '../PlaySound/PlaySoundBar';
import { useTranslation } from '../../../contexts/LanguageContext';
import SettingsButton from '../../Shared/SettingsButton';

interface GameHeaderProps {
    staticCursorImage: string;
}

const GameHeader = (props: GameHeaderProps) => {
    const gameContext = useContext(GameContext);
    const { t } = useTranslation();
    const theme = useTheme();
    const isPhone = useMediaQuery(theme.breakpoints.down('sm'));

    const backgroundButton = 'url(/images/buttons/menuButton1.png)';
    const backgroundButtonHover = 'url(/images/buttons/menuButton1_hover.png)';

    const [turnCount, setTurnCount] = useState(-1);

    const navigate = useNavigate();

    const backToMenuHandler = async () => {
        await gameContext.getClient().LeaveGame();
        navigate('/');
    };

    useEffect(() => {
        if (gameContext.currentTurn === undefined) {
            return;
        }
        setTurnCount(gameContext.currentTurn.turnCount);
    }, [gameContext.currentTurn]);

    return (
        <Stack
            spacing={2}
            direction="row"
            sx={{
                height: 'auto',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingLeft: '0.5%',
                paddingRight: '0.5%',
                paddingTop: '0.5%',
                display: 'flex'
            }}
        >
            <Stack
                direction="row"
                spacing={3}
                sx={{
                    height: 'auto',
                    width: '10%',
                    alignItems: 'center',
                    justifyContent: 'start'
                }}
            >
                <MenuButton
                    text={t('home')}
                    buttonWidth="100%"
                    textSize="h5"
                    onClick={backToMenuHandler}
                    background={backgroundButton}
                    hoverBackground={backgroundButtonHover}
                    dynamicCursor={false}
                    staticCursorImage={props.staticCursorImage}
                    disabled={false}
                />
                {!isPhone && <SettingsButton />}
            </Stack>

            <Box
                sx={{
                    height: 'auto',
                    width: '30%',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <PlaySoundBar />
            </Box>
            <Box
                sx={{
                    height: 'auto',
                    width: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                }}
            >
                <Typography variant="h4" sx={{ color: 'white', textShadow: '0 0 20px rgba(193, 145, 255, 0.4)', fontSize: 'clamp(1rem, 3vw, 2.125rem)', whiteSpace: 'nowrap' }}>
                    {`${t('turn')} ${turnCount}`}
                </Typography>
            </Box>
        </Stack>
    );
};

export default GameHeader;
